import Translation from './translation'
import Album from './album.js';

export default class Image extends Translation
{
    get active_ar() {
        return this.locales.includes('ar');
    }

    get active_en() {
        return this.locales.includes('en');
    }
    
    get active_fa() {
        return this.locales.includes('fa');
    }

    set Image(value){
        if(value != null){
            this.image = value
            this.picture = URL.createObjectURL(value)
        }else{
            this.image = null
            this.picture = this.image_url
        }
    }

    get ImageName(){
        var path = require('path');
        return this.image != null
            ? path.basename(this.image.value)
            : path.basename(this.image_url);
    }

    get ImageType(){
        return this.image != null
            ? this.image.type
            : this.ImageName.split('.').pop()
    }

    constructor(image){
        super()
        this.id             = 0
        
        this.locales        = []
        
        this.title_ar       = ''
        this.title_en       = ''
        this.title_fa       = ''
        
        this.description_ar = ''
        this.description_en = ''
        this.description_fa = ''

        this.published      = false

        this.thumbnails     = {}
        this.image          = null
        this.get_image_url  = null
        this.image_url      = null
        this.picture        = null
        this.tags           = []
        this.albums         = []

        this.map(image)
        this.init()
    }

    map(image){
        if(image == undefined) return
        this.id             = image.id
        this.get_image_url  = image.get_image_url
        this.image_url      = image.image_url
        this.picture        = ''
        this.thumbnails     = image.thumbnails
        
        this.published      = image.published_at != null
        this.tags           = image.tags??[]
        this.albums         = image.albums.map((a)=>new Album(a))??[]
        this.created_at     = image.created_at  
        this.updated_at     = image.updated_at  
        this.published_at   = image.published_at  

        for (let locale in image.translations) {
            this['title_' + locale] = image.translations[locale].title
            this['description_' + locale] = image.translations[locale].description??null
            this.locales.push(locale);
        }
        this.setLocale(this.locales)
    }

    toFormData(){
        let fData = new FormData()
        
        for(let locale of this.locales){

            fData.append('translation['+ locale +'][title]', this['title_'+ locale]);
            fData.append('translation['+ locale +'][description]', this['description_'+ locale]);
        }
        
        this.albums.forEach((album, index)=>fData.append('albums['+ index +']', album.id))

        fData.append('published', Number(this.published));

        if(this.image != null){
            fData.append('image', this.image);
        }

        this.tags.forEach(tag=>fData.append('tags[]', tag))
        return fData
    }
}

